import { Button } from "./ui/button";

interface TileCardProps {
  image: string;
  title: string;
  desc: string;
  buttonDesc: string;
  link: string; // New property for the link
}

const TileCard: React.FC<TileCardProps> = ({
  image,
  title,
  desc,
  buttonDesc,
  link, // Destructure the new property
}) => {
  return (
    <div className="text-center flex flex-col h-full">
      <img src={image} className="mx-auto" />
      <p className="text-xl font-bold mt-4">{title}</p>
      <p className="text-sm text-gray-400 mt-4 mb-4">{desc}</p>
      <a href={link} className="mt-auto w-full">
        <Button className="bg-yellow-400 text-black font-bold py-4 w-full mt-4">{buttonDesc}</Button>
      </a>
    </div>
  );
};

export default TileCard;
